import React from 'react';

const TEST_PAGE_PATH = '/test-preview.html';

const TestPage = () => (
  <main
    style={{
      width: '100%',
      height: '100vh',
      backgroundColor: '#080b11'
    }}
  >
    <iframe
      title="OS Desktop Pages"
      src={TEST_PAGE_PATH}
      style={{
        width: '100%',
        height: '100%',
        border: 0,
        display: 'block'
      }}
    />
  </main>
);

export default TestPage;
